import React from 'react';
import NewsItem from './NewsItem.tsx';
import { NewsItem as NewsItemType } from './useNewsData.ts';

interface DesktopNewsProps {
    newsItems: NewsItemType[];
    bulletStyle: string;
    cvLink: string;
}

const DesktopNews: React.FC<DesktopNewsProps> = ({ newsItems, bulletStyle, cvLink }) => {
    return (
        <>
            <p className="text-textGrey font-condensed text-center font-extralight text-lg">
                Most Updated <a className="text-textRed hover:underline" href={cvLink}>CV</a>
            </p>
            <br />
            <ul className="text-textGrey text-lg text-left font-condensed font-extralight w-[65.625rem] h-auto list-none">
                {newsItems.map((item, index) => (
                    <NewsItem
                        key={index}
                        date={item.date}
                        country={item.country}
                        countryCode={item.countryCode}
                        bulletStyle={bulletStyle}
                    />
                ))}
            </ul>
        </>
    );
};

export default DesktopNews;